import styled from 'styled-components';

export const ModalBoxWrap = styled.div`
		position: absolute;
    top: .375rem;
    left: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
		z-index: 9;
		overflow: inherit;

		&.strip-update-modalbox{
		 left: 50%;
		 right: inherit;
		 transform: translateX(-50%);
		 z-index: 10;
		 label{
		 	white-space: nowrap;
		 }
		 @media (max-width: 590px){
		 		left: 1%;
        transform: translateX(0);
		 }

		}
		 &.prompt-modalbox {
			top: 88%;
			left: 50%;
			transform: translateX(-50%);
			
		}
		 &.fullscreen{
		  right: 6px;
			left: inherit;

			@media (max-width: 768px){
				top: 4.35rem;
				left: 14px;
				right: auto;
				transform: translateX(0);
			}
			@media (max-width: 540px){
				top: 4.35rem;
				left: 14px;
				right: auto;
				transform: translateX(0);
			}
		 }
			> div{
				position: relative; 
			}
		
		@media (max-width: 540px){
		 top: .45rem;
		 right: 5%;
		 transform: translateX(0);
      justify-content: center;
		}

		&.edgetool-modalbox {
			@media (max-width: 768px){
				top: 12px;
				left: 14px;
				right: auto;
				transform: translateX(0);
			}
			@media (max-width: 700px){
				top: 4.35rem;
				left: 14px;
				right: auto;
				transform: translateX(0);
			}
			@media (max-width: 540px){
				top: 4.35rem;
				left: 14px;
				right: auto;
				transform: translateX(0);
			}

			&.fullscreen{
				@media (max-width: 768px){
					top: 4.35rem;
					left: 14px;
					right: auto;
					transform: translateX(0);
				}
				@media (max-width: 540px){
					top: 4.35rem;
					left: 14px;
					right: auto;
					transform: translateX(0);
				}
			}
		}

		&.with-auto-detect {
			@media (max-width: 768px){
				top: 4.35rem;
			}
			@media (max-width: 540px){
				top: 4.35rem;
			}
		}
`;
export const ModalBox = styled.div`
		display: flex;
		align-items: center;
		flex-direction: column;
		pointer-events: all;
		// overflow: hidden;
		padding: .275rem 0.275rem;
		gap: 8px;

`;

export const StripDiv = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	border: none;
	padding: 0;
	background: transparent;
	position: relative;
	flex-direction: column;
	transition-delay: 1s;

		&.strip-update{
			padding: 0.225rem 1.25rem;
			background: var(--modalBgColor);
			border-radius: 91px;
			flex-direction: row;
			box-shadow: 0 4px 8px rgb(0 0 0 / 12%);
		}

		// .active-strip{
		// 	background: #003cff;
		// }
`;
export const DropdownBtn = styled.div`
		cursor: pointer;
		font-size: 0.925rem;
		color: var(--subHeadingColor);
		font-family: Inter;
		font-weight:600;
		position:relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: .5rem;
		min-height: 40px;
		border-right: none;
		padding: 0.45rem 0.625rem 0.45rem 0.875rem;
		border: 1px solid var(--modalBorderColor);
		border-radius: 91.4939px;
		background: var(--modalBgColor);
		margin: 0px;
		width: 154px;

		&.active{
			color: #fff;
			background: var(--primary);
			border-color: var(--primary);

			span{
				color: #fff;
			}
		}

		label{
				display: flex;
				gap: 8px;
				justify-content: center;
				cursor: pointer;
			}
		.arrow-down{
		transition: transform 0.3s ease;
			float: right;
			display: flex;

			&.active{
				transform: rotate(180deg);
			}
		}
	&.not-allowed{
		cursor: not-allowed;
		label{
			cursor: not-allowed;
			svg,span{
				cursor: not-allowed;
			}
		}
	}		
			
}
`;

export const DrodownList = styled.ul`
	position: relative;
	width: 154px;
	top: 2px;
	left: 0px;
	margin: 0;
	padding: 10px 2px;
	list-style: none;
	background-color: var(--selectDropdownBgColor);
	border: 1px solid rgb(204 204 204 / 45%);
	boxShadow: 0 2px 10px rgba(0,0,0,0.2);
	border-radius: 4px 4px;
	transition: transform 0.2s ease;
	z-index: 20;
	cursor: pointer;


	&.not-allowed{
		li:not(.selected){
				cursor: not-allowed;
				background: none !important;
			&:hover{
				background: none !important;
			}
		
		}
	}

	li{
			padding: 6px;
			cursor: pointer;
			display: flex;
			align-items: center;
			gap:10px;
			font-size: 0.875rem;
			color: var(--textColor);

			&:hover{
				background: var(--toolbarBgColor) !important;
			}

			span{
				width: 26px;
				display: flex;
				borader-radius: 4px;
				position: relative;
    		top: 1px;
			}
	}
			&.gutter-list{
				li{
					gap: 10px;
					span{
						width: auto;
						top:0;
					}
				}

			}
`;

export const LabelInfo = styled.div`
		font-size: 0.925rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		font-weight:600;
		position:relative;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: .5rem;
		min-height:27px;
		border-right: none;
		padding-right: .25rem;
		margin-right: 2px;
`;

export const PromptModal = styled.div`
	display; flex;
	font-family: Inter;
	transition-delay: 1s;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: .5rem;
	padding: 1.125rem 1.5rem;
	borderRadius: 8px;
	background: var(--modalBgColor);
	border-radius: 8px;
	font-size: .95rem; 
	min-width: 276px;   
	p{
		margin: 0;
		color: var(--subHeadingColor);
	}
`;

export const Button = styled.button`
		border: none;
    color: var(--subHeadingColor);
    padding: .125rem .35rem;
    box-shadow: none;
    background: none;
		position: relative;
		top: 2px;
		cursor: pointer;
`;